/**
 * Shopify Dynamic Schema.org Updater
 * 
 * This script automatically updates the Product Schema price when a variant is selected.
 * It listens for:
 * 1. URL changes (variant query parameters)
 * 2. Form changes (when users click options)
 * 3. AJAX Cart updates (if available)
 */

document.addEventListener('DOMContentLoaded', function() {
    console.log('Shopify Schema Updater Loaded');

    // Configuration - Adjust selectors to match your specific Theme if needed
    const config = {
        priceSelector: '.price-display, .product__price, .price-item--regular, .price__regular .price-item, [data-product-price]', // Common Shopify price selectors
        variantSelector: 'select[name="id"], input[name="id"]', // Common variant input names
        schemaSelector: 'script[type="application/ld+json"]'
    };

    /**
     * Updates the existing JSON-LD schema with the current displayed price
     */
    function updateSchemaPrice() {
        // 1. Find the current visible price
        // We look for the first visible price element to avoid hidden "compare at" prices
        const priceElements = document.querySelectorAll(config.priceSelector);
        let currentPriceText = '';
        
        for (let el of priceElements) {
            if (el.offsetParent !== null) { // Check if visible
                currentPriceText = el.innerText;
                break;
            }
        }

        if (!currentPriceText) return;

        // Clean the price string (remove currency symbols, whitespace)
        const cleanPrice = currentPriceText.replace(/[^0-9.]/g, '');
        
        if (!cleanPrice) return;

        // 2. Update the Schema
        const schemaScripts = document.querySelectorAll(config.schemaSelector);
        
        schemaScripts.forEach(script => {
            try {
                const schema = JSON.parse(script.textContent);
                
                // Check if this is a Product schema
                if (schema['@type'] === 'Product' || schema['@type'] === 'http://schema.org/Product') {
                    let updated = false;

                    // Update main Offer
                    if (schema.offers && (schema.offers['@type'] === 'Offer' || schema.offers['@type'] === 'http://schema.org/Offer')) {
                        if (schema.offers.price !== cleanPrice) {
                            schema.offers.price = cleanPrice;
                            updated = true;
                        }
                    }
                    // Update AggregateOffer (if used)
                    else if (schema.offers && (schema.offers['@type'] === 'AggregateOffer' || schema.offers['@type'] === 'http://schema.org/AggregateOffer')) {
                        if (schema.offers.lowPrice) {
                             // Note: For aggregates, we might only want to update if we are sure, 
                             // but usually single product pages switch to a specific Offer when a variant is picked.
                             // This part is trickier without knowing the exact theme logic.
                        }
                    }

                    if (updated) {
                        script.textContent = JSON.stringify(schema, null, 2);
                        console.log('Schema price updated to:', cleanPrice);
                    }
                }
            } catch (e) {
                // Ignore parse errors (common if liquid outputs invalid JSON)
            }
        });
    }

    // --- Observers & Event Listeners ---

    // 1. Listen for URL changes (Shopify often updates URL to ?variant=123)
    let lastUrl = location.href; 
    new MutationObserver(() => {
        const url = location.href;
        if (url !== lastUrl) {
            lastUrl = url;
            setTimeout(updateSchemaPrice, 500); // Wait for DOM update
        }
    }).observe(document, { subtree: true, childList: true });

    // 2. Listen for Form Changes (Variant Pickers)
    const forms = document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(form => {
        form.addEventListener('change', () => {
             setTimeout(updateSchemaPrice, 500); // Wait for price to update
        });
    });

    // 3. Observer for Price DOM changes (The most robust method)
    // If the theme uses JS to update the price text, this will catch it.
    const priceNodes = document.querySelectorAll(config.priceSelector);
    if (priceNodes.length > 0) {
        const priceObserver = new MutationObserver((mutations) => {
            updateSchemaPrice();
        });
        
        priceNodes.forEach(node => {
            priceObserver.observe(node, { characterData: true, subtree: true, childList: true });
        });
    }
});
